<div class="tab-options-container">
  <span class="tab-option" *ngFor="let option of options" (click)="setOption(option)" [class.tab-option-active]="selectedOption == option">
    {{option.translationKey | translate}}
  </span>
</div>
